// extracted by mini-css-extract-plugin
var _1 = "TestHotspotDemo_block__0fb3a";
var _2 = "TestHotspotDemo_blockWrapper__6b109";
var _3 = "TestHotspotDemo_image__e3227";
var _4 = "TestHotspotDemo_root__0e10e";
export { _1 as "block", _2 as "blockWrapper", _3 as "image", _4 as "root" }
